'use client'

import { createApi } from '@reduxjs/toolkit/query/react'

import {
  TransicionDisponible,
  TransicionesDisponiblesReserva,
} from '../interfaces/TransicionDisponible'
import { TransicionesPermitidas } from '../interfaces/TransicionesPermitidas'
import {
  VerifyChangeStateRequest,
  VerifyChangeStateResponse,
} from '../interfaces/VerifyChangeState'

import { baseQuery } from '@/core/api/baseQuery'

export const reservaCentralizadaBusinessApi = createApi({
  reducerPath: 'reservaCentralizadaBusinessApi',
  baseQuery,
  endpoints: (builder) => ({
    getFileName: builder.query<string, number>({
      query: (id) => ({
        url: `ReservaCentralizadaBusiness/GenerarPrevisualizacionCarta?reservaCentralizadaId=${id}`,
        method: 'GET',
        responseHandler: async (response: Response): Promise<string> => {
          const texto = await response.text()

          return texto.startsWith('"') && texto.endsWith('"') ? (JSON.parse(texto) as string) : texto
        },
      }),
      keepUnusedDataFor: 0,
    }),
    changeStateBooking: builder.mutation<
      VerifyChangeStateResponse[],
      VerifyChangeStateRequest[]
    >({
      query: (body) => ({
        url: `/ReservaCentralizadaBusiness/CambiarEstadoReservas`,
        method: 'POST',
        body,
      }),
    }),
    allowedTransitions: builder.query<TransicionesPermitidas[], void>({
      query: () => ({
        url: `/ReservaCentralizadaBusiness/GetTransicionesReservas`,
        method: 'GET',
      }),
    }),
    // Reglas de negocio evaluadas por reserva. Sin cache: queda obsoleto en cuanto
    // cambia el estado de la reserva o de sus detalles.
    transicionesDisponibles: builder.query<TransicionDisponible[], number>({
      query: (reservaCentralizadaId) => ({
        url: `/ReservaCentralizadaBusiness/TransicionesDisponibles?reservaCentralizadaId=${reservaCentralizadaId}`,
        method: 'GET',
      }),
      keepUnusedDataFor: 0,
    }),
    // Una sola llamada para todo el lote arrastrado. Con una petición por reserva, una selección
    // de cien dejaba a varias sin veredicto a tiempo y el tablero decidía a ciegas.
    transicionesDisponiblesLote: builder.query<TransicionesDisponiblesReserva[], number[]>({
      query: (reservaCentralizadaIds) => ({
        url: `/ReservaCentralizadaBusiness/TransicionesDisponiblesLote`,
        method: 'POST',
        body: reservaCentralizadaIds,
      }),
      keepUnusedDataFor: 0,
    }),
    regenerarCartaListaPasajeros: builder.mutation<
      { urlCartaEnviada: string },
      { reservaCentralizadaId: number; enviarCorreo: boolean }
    >({
      query: (body) => ({
        url: `/ReservaCentralizadaBusiness/RegenerarCartaListaPasajeros`,
        method: 'POST',
        body,
      }),
    }),
  }),
})

export const {
  useLazyGetFileNameQuery,
  useChangeStateBookingMutation,
  useLazyAllowedTransitionsQuery,
  useLazyTransicionesDisponiblesQuery,
  useLazyTransicionesDisponiblesLoteQuery,
  useRegenerarCartaListaPasajerosMutation,
} = reservaCentralizadaBusinessApi
